<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6 dms-modal" 
    >

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="modal_title">Note</div>
        <button mat-icon-button (click)="cancel()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Compose form -->
    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
        <mat-label>Note</mat-label>
        <quill-editor class="mt-2" [(ngModel)]="note.comment" name="note" [ngModelOptions]="{standalone: true}" [bounds]="'self'"
            [modules]="getEditorToolbar()" style=" height: '450px'">
        </quill-editor>
        
        <small class="text-muted" *appIsDisplayed="'isUserTaggingSupported'">
            <!-- <mat-icon [svgIcon]="'mat_solid:lightbulb'" class="icon-size-4 text-xs" style="color:#ffa962"></mat-icon> -->
            To tag another user in your note, type <b>&#64;</b> and then the user's name.
        </small>

        <!-- <textarea matInput class="mt-2" placeholder="Note..." rows="3" [(ngModel)]="note.comment"
                name="comment"></textarea> -->
        <!-- Actions -->
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">

                <!-- Insert link -->
                <!-- <button mat-icon-button>
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:link'"></mat-icon>
                </button> -->

            </div>

            <div class="flex items-center mt-4 sm:mt-0">
                <!-- Cancel -->
                <button class="ml-auto sm:ml-0 mr-2" mat-stroked-button (click)="cancel()">
                    Cancel
                </button>
                <!-- Save -->
                <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" [disabled]="!note.comment"
                    (click)="submit()">
                    <span *ngIf="!isLoading">Save</span>
                    <mat-progress-spinner *ngIf="isLoading" [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
                </button>
            </div>
        </div>

    </form>
</div>